import React from 'react';
import { useShow } from '@refinedev/core';
import { useTranslation } from 'react-i18next';
import { Show, DateField, ListButton } from '@refinedev/mui';
import { Typography, Stack, Chip, Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ui';
import { Researcher } from '@aphp-ema/common/researchers';

export const UserShow = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const {
    query: { data, isLoading },
  } = useShow<Researcher>({
    id,
  });

  const record = data?.data;

  return (
    <ErrorBoundary>
      <Show
        isLoading={isLoading}
        recordItemId={id}
        canDelete={false}
        title={t('pages.users.title')}
        headerButtons={({ listButtonProps }) => (
          <>
            <ListButton {...listButtonProps} />
          </>
        )}
      >
        <Stack gap={1}>
          <Typography variant="body1" fontWeight="bold">
            ID
          </Typography>
          <Typography variant="body2">{record?.id}</Typography>

          <Typography variant="body1" fontWeight="bold" mt={2}>
            {t('pages.users.fields.email')}
          </Typography>
          <Typography variant="body2">{record?.email}</Typography>

          <Typography variant="body1" fontWeight="bold" mt={2}>
            {t('pages.users.fields.firstName')}
          </Typography>
          <Typography variant="body2">{record?.firstName}</Typography>

          <Typography variant="body1" fontWeight="bold" mt={2}>
            {t('pages.users.fields.lastName')}
          </Typography>
          <Typography variant="body2">{record?.lastName}</Typography>

          <Typography variant="body1" fontWeight="bold" mt={2}>
            {t('pages.users.fields.roles')}
          </Typography>
          <Box>
            <Chip
              key={record?.role}
              // @ts-expect-error Dynamic label
              label={t(`roles.${record?.role?.toLowerCase()}`)}
              color="primary"
              size="small"
              sx={{ mr: 0.5, mb: 0.5 }}
            />
          </Box>

          <Typography variant="body1" fontWeight="bold" mt={2}>
            {t('pages.users.fields.createdAt')}
          </Typography>
          <DateField value={record?.createdAt} />
        </Stack>
      </Show>
    </ErrorBoundary>
  );
};
